import React, { useState, useRef, useEffect } from "react";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import Config from "../../Config";
import FilterCheckNotebook from "../filters/FilterCheckNotebook";
import WordInsertions from "../../utils/WordInsertions";
import ColumnsCustomizer from "./ColumnsCustomizer";

import '../../styles/Modal.css';
import MetamodelStore from "../../resources/data/MetamodelStore";

/**
 * Modal for inserting table with model type's/object's properties
 */
const ModalTableAttrsRel = ({ sTitle, aNotebook, isOpen, bIsModelObj = false, onClose }) =>
{
  const [bNoValueAllow, setBNoValueAllow] = useState(false);

  const aFilterCheckRef = useRef();
  const aColumnsCustom = useRef();

  const handleFilterConfirm = () =>
  {
    const aColumnsOrder = aColumnsCustom.current.getColumnsOrder();
    const aSelection = aFilterCheckRef.current.getSelection();

    const aSelectedAttrs = aColumnsOrder.map(aItem =>
    {
      return aSelection.find(aItemInner => aItemInner.name === aItem);
    }).filter(aItem => aItem);

    if (aSelectedAttrs.length > 0)
    {
      WordInsertions.insertAttrTable(aSelectedAttrs, bNoValueAllow);
    }
  };

  const refreshAttributesSelection = () =>
  {
    const aSelection = aFilterCheckRef.current.getSelection();
    aColumnsCustom.current.setItems(aSelection);
    // Force re-render
    setBNoValueAllow(bNoValueAllow => !bNoValueAllow);
  };

  const noValueToggle = (bState) =>
  {
    setBNoValueAllow(bState);
  };

  const closeModal = () =>
  {
    onClose();
  };


  if (!isOpen)
  {
    return null;
  }

  return (
    <div className="PopupBackground">
      <div className="PopupContent">
        <h3 className="Modal__label">{sTitle}</h3>

        <FilterCheckNotebook
          aNotebook={aNotebook}
          ref={aFilterCheckRef}
          bIsModelObj={bIsModelObj}
          onChangeCallback={refreshAttributesSelection}
          preventRelationNotebook={true}
        />

        <h4 className="Modal__label">
          <KeyboardArrowDownIcon classes={{ root: "Modal__label__icon" }} />
          <KeyboardArrowUpIcon classes={{ root: "Modal__label__icon" }} />
          {' '}
          {Config.strings.modals.modelAttrs.sTitleRowsList.concat(":")}
        </h4>
        <ColumnsCustomizer
          ref={aColumnsCustom}
          bShiftEnable={true}
          bSortEnable={false}
        />

        <div className="Modal__filter">
          <input
            type="checkbox"
            checked={bNoValueAllow}
            onChange={(aEvent) =>
            {
              noValueToggle(aEvent.currentTarget.checked);
            }}
          />
          <label>
            {Config.strings.modals.modelAttrs.sFilterNoValue}
          </label>
        </div>

        <button className="wrcButton wrcButton--confirm" onClick={(aEvent) =>
        {
          aEvent.preventDefault();
          closeModal();
          handleFilterConfirm();
        }}>
          {Config.strings.modals.modelAttrs.sConfirmLabel}
        </button>
        <button className="wrcButton wrcButton--confirm" onClick={(aEvent) =>
        {
          aEvent.preventDefault();
          closeModal();
        }}>
          {Config.strings.modals.modelAttrs.sRejectLabel}
        </button>
      </div>
    </div>
  );
};

export default ModalTableAttrsRel;
